export enum SaveStatus {
    Unsaved,
    Saving,
    Saved,
    Error,
}